"use strict";

var _regeneratorRuntime = require("/home/runner/work/prodigies-brochure/prodigies-brochure/node_modules/.pnpm/@babel+runtime@7.19.0/node_modules/@babel/runtime/regenerator");

require("regenerator-runtime/runtime");

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Form = exports.OnValuesChangeWatcher = exports.ReactFormContextProvider = exports.useFormSubmit = exports.useReactFormContext = exports.ReactFormContext = void 0;

var react_1 = __importDefault(require("react"));

var react_hook_form_1 = require("react-hook-form");

var InnerForm_1 = require("./InnerForm");

exports.ReactFormContext = react_1.default.createContext(undefined);

function useReactFormContext() {
  var context = react_1.default.useContext(exports.ReactFormContext);

  if (!context) {
    throw new Error('ReactFormContext is required, but not provided.');
  }

  return context;
}

exports.useReactFormContext = useReactFormContext;

function useFormSubmit() {
  var _useReactFormContext = useReactFormContext(),
      handleSubmit = _useReactFormContext.handleSubmit;

  return function (e) {
    return handleSubmit(e || {});
  };
}

exports.useFormSubmit = useFormSubmit;

function ReactFormContextProvider(_ref) {
  var _this = this;

  var onFinish = _ref.onFinish,
      onFinishFailed = _ref.onFinishFailed,
      onValuesChange = _ref.onValuesChange,
      form = _ref.form,
      children = _ref.children;
  return react_1.default.createElement(exports.ReactFormContext.Provider, {
    value: {
      form: form,
      control: form.control,
      handleSubmit: form.handleSubmit(onFinish, function () {
        return __awaiter(_this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
          return _regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  if (!onFinishFailed) {
                    _context.next = 3;
                    break;
                  }

                  _context.next = 3;
                  return onFinishFailed(form.getValues());

                case 3:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee);
        }));
      })
    }
  }, onValuesChange ? react_1.default.createElement(OnValuesChangeWatcher, {
    onValuesChange: onValuesChange,
    form: form
  }) : null, children);
}

exports.ReactFormContextProvider = ReactFormContextProvider;

function OnValuesChangeWatcher(_ref2) {
  var onValuesChange = _ref2.onValuesChange,
      form = _ref2.form;
  var values = onValuesChange ? form.watch() : undefined; // We have to stringify because it looks like the watcher returns a different value by reference each time.

  react_1.default.useEffect(function () {
    if (onValuesChange && values) {
      onValuesChange(values);
    }
  }, [JSON.stringify(values)]);
  return null;
}

exports.OnValuesChangeWatcher = OnValuesChangeWatcher;

function Form(_ref3) {
  var form = _ref3.form,
      onFinish = _ref3.onFinish,
      onFinishFailed = _ref3.onFinishFailed,
      onValuesChange = _ref3.onValuesChange,
      children = _ref3.children;
  return react_1.default.createElement(react_hook_form_1.FormProvider, Object.assign({}, form), react_1.default.createElement(ReactFormContextProvider, {
    form: form,
    onFinish: onFinish,
    onFinishFailed: onFinishFailed,
    onValuesChange: onValuesChange
  }, react_1.default.createElement(InnerForm_1.InnerForm, {
    children: children
  })));
}

exports.Form = Form;